// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"d1869e4e","583":"45a24a25","708":"f12cea46","869":"efe34160"}[chunkId] + ".chunk.js";
};